import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { LanguageProvider } from './i18n';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/admin/Dashboard';
import ShipmentsPending from './pages/admin/ShipmentsPending';
import PendingByCustomer from './pages/admin/PendingByCustomer';
import ShipmentsAssigned from './pages/admin/ShipmentsAssigned';
import Flights from './pages/admin/Flights';
import Customers from './pages/admin/Customers';
import Accounts from './pages/admin/Accounts';
import MyAccount from './pages/MyAccount';
import MyShipments from './pages/customer/MyShipments';
import RegisterCodes from './pages/admin/RegisterCodes';
import FindCodes from './pages/admin/FindCodes';

const ProtectedRoute = ({ children, roles }) => {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ background: 'var(--bg-primary)', minHeight: '100vh' }} />;
  if (!user) return <Navigate to="/login" />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/login" />;
  return children;
};

const AdminRoute = ({ children }) => (
  <ProtectedRoute roles={['superadmin', 'staff']}>
    <Layout>{children}</Layout>
  </ProtectedRoute>
);

export default function App() {
  return (
    <LanguageProvider>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard"           element={<AdminRoute><Dashboard /></AdminRoute>} />
          <Route path="/shipments/pending"   element={<AdminRoute><ShipmentsPending /></AdminRoute>} />
          <Route path="/shipments/by-customer" element={<AdminRoute><PendingByCustomer /></AdminRoute>} />
          <Route path="/shipments/assigned"  element={<AdminRoute><ShipmentsAssigned /></AdminRoute>} />
          <Route path="/flights"             element={<AdminRoute><Flights /></AdminRoute>} />
          <Route path="/customers"           element={<AdminRoute><Customers /></AdminRoute>} />
          <Route path="/register-codes"      element={<AdminRoute><RegisterCodes /></AdminRoute>} />
          <Route path="/find-codes"          element={<AdminRoute><FindCodes /></AdminRoute>} />
          <Route path="/accounts"            element={<ProtectedRoute roles={['superadmin']}><Layout><Accounts /></Layout></ProtectedRoute>} />
          <Route path="/my-account"          element={<AdminRoute><MyAccount /></AdminRoute>} />
          <Route path="/my-shipments"        element={<ProtectedRoute roles={['customer']}><MyShipments /></ProtectedRoute>} />
          <Route path="*"                    element={<Navigate to="/login" />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </LanguageProvider>
  );
}
